import { Injectable } from "@angular/core";
import { AngularFireList, AngularFireDatabase } from "@angular/fire/database";
import { BehaviorSubject, Subject, Observable } from "rxjs";
import { AngularFireStorage } from "angularfire2/storage";
import { finalize, map } from "rxjs/operators";
import { Auto, Sante, SimulMoney } from "./ModelCotations";

import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { SharedService } from "../sheared/sharedService.service";
import { authenticationService } from "../Authentication/authentication.service";
import { isUndefined } from "util";
import { FactoryService } from "../historique/factory.service";
import { ThrowStmt } from "@angular/compiler";
import { NotificationService } from "../Notifications/notification.service";

@Injectable({
  providedIn: "root",
})
export class CotationService implements Resolve<Observable<any[]>> {
  navig = new BehaviorSubject("/");
  resgiter = new BehaviorSubject(false);
  loadPaieSimulate = new BehaviorSubject(false);
  userUid: string;
  emal: string;
  codeAssur: string;
  readyToGo: Subject<boolean> = new Subject();
  private List: any[] = [];
  private donnSimul = new BehaviorSubject(null);
  cotations = new BehaviorSubject<any[]>([]); // quittance[]=any
  dataClient: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  loading2: HTMLIonLoadingElement;
  private dataStore: { cotations: any[] } = { cotations: [] };
  private $uid;
  livrerObject = new BehaviorSubject(null);
  couverture = new BehaviorSubject(null);
  private i: number = 0;
  private myUID;
  returnResultPartage = new BehaviorSubject("");
  //private codeAssur:string
  constructor(
    private db: AngularFireDatabase,
    private storage: AngularFireStorage,
    private sharedService: SharedService,
    private authentic: authenticationService,
    private toastctl: ToastController,
    private _fact: FactoryService,
    private loadingController: LoadingController,
    private _notify: NotificationService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.codeAssur = this._fact.getData(201);
    this.loading2 = await this.loadingController.create({
      message: "Chargement...",
      duration: 30000,
      mode: "ios",
      spinner: "bubbles",
    });

    await this.loading2.present();

    //this.ajouSante()
    await this.historiqueCotations0().then((res) => {
      this.dataStore.cotations = res; //await res.sort((a,b) =>(a.dateInt<b.dateInt)? 1:-1); //res
      //this._cotations.next(Object.assign({}, this.dataStore).cotations)
      this.loading2.dismiss();
      return Object.assign({}, this.dataStore).cotations;
    });
    return null;
  }

  getaccessoires() {
    //this.codeAssur
    this.db
      .list("Accessoires/1010", (ref) => ref.orderByValue())
      .snapshotChanges(["child_added"])
      .subscribe((actions) => {
        const ListAccessoire = [];
        actions.forEach((action) => {
          ListAccessoire.push({
            acc: action.payload.exportVal().acc,
            min: action.payload.exportVal().min,
            max: action.payload.exportVal().max,
          });
        });
        //this.ListAccessoire.next(ListAccessoire)
        //return ListAssreurs
      });
  }

  mustBeDelete(item: any) {
    return this.db.database.ref().child(`Quittances/${item.Quittance}`); //.orderByChild("solde").equalTo('false')
  }
  async deleteQuit(item: any) {
    this.loading2 = await this.loadingController.create({
      message: "Suppression en cours...",
      duration: 30000,
      mode: "ios",
      spinner: "bubbles",
    });
    await this.loading2.present();

    return await this.db.database
      .ref()
      .child(`Quittances/${item.Quittance}`)
      .remove();
  }
  deleteCot(item: any) {
    return this.db.database
      .ref()
      .child(`Cotations/${this.authentic.profile.uid}/${item.type}/${item.key}`)
      .remove();
  }
  deleteImage(filePath0: string, filePath1: string = "") {
    this.readyToGo.next(false); //Mettre true

    if (filePath1) {
      this.storage
        .ref(filePath0)
        .delete()
        .subscribe(() =>
          this.storage
            .ref(filePath1)
            .delete()
            .subscribe(() => this.readyToGo.next(true))
        );
    } else {
      this.storage
        .ref(filePath0)
        .delete()
        .subscribe(() => this.readyToGo.next(true));
    }
  }

  async presentEtatDelete(msg: string) {
    const toast = await this.toastctl.create({
      animated: true,
      //  closeButtonText: "Ok",
      // color: 'danger',
      // cssClass: 'toast-success',
      duration: 3000,
      header: "Suppression de simulation !!",
      // keyboardClose: true,
      message: msg,
      mode: "ios",
      position: "bottom",
      //showCloseButton: true,
      translucent: true,
    });
    toast.present();
  }

  async actionSimul(header: string, msg: string) {
    const toast = await this.toastctl.create({
      animated: true,
      //closeButtonText: "Ok",
      // color: 'danger',
      // cssClass: 'toast-success',
      duration: 5000,
      header: header,
      // keyboardClose: true,
      message: msg,
      mode: "ios",
      position: "bottom",
      // showCloseButton: true,
      translucent: true,
    });
    toast.present();
    this.returnResultPartage.next("fin");
  }
  loadCotationHisto(idPar: string, idkey: string, type: string) {
    this.myUID = "";
    try {
      if (
        (this.authentic.profile.uid === idkey && idPar) ||
        idPar === undefined ||
        (idPar === null && idkey === null)
      ) {
        //envoyée  ou pas de partage
        this.myUID = this.authentic.profile.uid;
      } else if (this.authentic.profile.uid === idPar) {
        //reçu
        this.myUID = idkey;
      }

      this.i = 0;
      if (type) {
        this.historiqueCotations(type);
      } else {
        ["Sante", "Auto", "Voyage", "Individuelle", "Mrh"].forEach((e) => {
          this.historiqueCotations(e);
        });
      }
    } catch (error) {}
  }

  private async historiqueCotations(rubrique) {
    this.cotations.next([]);
    this.db
      .list(`Cotations/${this.myUID}/${rubrique}`)
      .snapshotChanges(["child_added"])

      .subscribe((actions) => {
        let List = [];
        let valbtnSuppr, valbtnTrans;

        List = actions.map(
          (c) => {
            this.i++;
            if (c.payload.exportVal().idkeyPar) {
              if (this.authentic.profile.uid === this.myUID) {
                (valbtnTrans = false), (valbtnSuppr = true);
              } else if (
                c.payload.exportVal().idkeyPar === this.authentic.profile.uid
              ) {
                (valbtnTrans = false), (valbtnSuppr = false);
              }
            } else {
              (valbtnTrans = true), (valbtnSuppr = true);
            }
            //let val=c.payload.val()
            return {
              i: this.i,
              activeBtnSuppr: valbtnSuppr,
              activeBtnTrans: valbtnTrans,
              key: c.payload.key,
              ...(c.payload.val() as any),
            };
          }
          //(List.push({ key: c.payload.key, ...c.payload.val() }))
        );

        this.cotations.next(List);
        // if (List.length > 0) {
        //   this.cotations.next(List)
        // }
      });
  }
  async historiqueCotations0() {
    var handelResult = [];
    const tree = this.db.database.ref();
    if (isUndefined(this.userUid) || this.userUid == "") {
      this.userUid = this.authentic.profile.uid;
    }

    const ref2 = tree
      .child("Cotations/" + this.userUid)

      // await ref2.orderByChild('uid').equalTo(this.userUid)
      //.orderByChild('nomAssureur').equalTo(profil.nomAssureur)
      .on("child_added", (snapshot) => {
        const $key = snapshot.key; // clé hashée de cotation
        tree
          .child(`Cotations/${this.userUid}/${$key}`)
          .once("value", (snap) => {
            handelResult.push({
              $key: $key,
              ref: $key.substr(-5),
              uid: snap.val().uid,
              dateIns: this.sharedService.TimeStampToformatDMY(
                snap.val().dateIns
              ),
              dateInt: snap.val().dateIns,
              livraison: snap.val().livraison,
              Periode: snap.val().Periode,
              assureur: snap.val().assureur,
              imageUrl: snap.val().imageUrl,
              response: snap.val().response,
              type: snap.val().type,
              icon: snap.val().icon,
              typeformule0: snap.val().typeformule0,
              typeformule1: snap.val().typeformule1,
              adulte: snap.val().adulte,
              enfant: snap.val().enfant,
              observation: snap.val().observateur,
            });

            //console.log(handelResult);
          });
      });

    return await handelResult; //this.PrepareData(handelResult)
  }

  userProfil() {
    if (isUndefined(this.userUid) || this.userUid == "") {
      this.userUid = this.authentic.profile.uid;
    }
  }

  getvalSimulatePaie() {
    return this.loadPaieSimulate.asObservable();
  }
  setvalSimulatePaie(val: boolean) {
    this.loadPaieSimulate.next(val);
  }
  getdataSimulateMoney($uid) {
    this.gestSimulateMoney($uid);
    return this.donnSimul.asObservable();
  }
  async addSimulalteMoney($uid, refS) {
    await this.db.list(`ParaSimul/${$uid}`).push(refS);
  }
  updateSimulalteMoney(data: any[]) {
    data.forEach((e) => {
      //if (e.valid) {
      this.db.object(`ParaSimul/${this.$uid}/${e.key}`).update({
        retraitMontant: e.retraitMontant,
        revenuMontant: e.revenuMontant,
        valid: false, //e.valid
      });
      //  }
    });
  }
  private gestSimulateMoney($uid) {
    this.$uid = $uid;
    this.db
      .list(`ParaSimul/${$uid}`, (ref) =>
        ref.orderByChild("valid").equalTo(true)
      )
      .snapshotChanges(["child_added"])
      .subscribe((actions) => {
        let List = [];
        // this.donnSimul.next(null)
        if (actions.length > 0) {
          actions.map((c) => {
            return List.push({
              key: c.payload.key,
              p: c.payload.val(),
            });
          });

          if (List.length > 0) {
            this.donnSimul.next(List);
          }
        } else {
          this.donnSimul.next([]);
        }
      });
    // this.db.list("ParaSimul").push(refS)
  }

  async getCustom(tel: string) {
    this.loading2 = await this.loadingController.create({
      message: "Recherche en cours...",
      duration: 30000,
      mode: "ios",
      spinner: "bubbles",
    });
    await this.loading2.present();
    this.db
      .list("CLIENTS", (ref) =>
        ref.orderByChild("tel1").equalTo(tel).limitToFirst(1)
      )
      .snapshotChanges(["child_added"])
      .subscribe((actions) => {
        const Listclient = [];
        let i = 0;

        actions.forEach((action) => {
          i++;
          let p = action.payload.exportVal();

          Listclient.push({
            NomPrenom: p.NomPrenom.trim(),
            tel1: p.tel1.toString(),
            tel2: p.tel2.toString(),
            uid: p.uid,
            registerid: p.register_id,
          });
        });

        this.dataClient.next(Listclient);
        this.loading2.dismiss();
        // return this.ListAssreurs
      });
  }

  getCustomUID(uid: string) {
    this.db
      .list("CLIENTS", (ref) =>
        ref.orderByChild("uid").equalTo(uid).limitToFirst(1)
      )
      .snapshotChanges(["child_added"])
      .subscribe((actions) => {
        const Listclient = [];
        let i = 0;

        actions.forEach((action) => {
          i++;
          let p = action.payload.exportVal();
          Listclient.push({
            NomPrenom: p.NomPrenom.trim(),
            tel1: p.tel1.toString(),
            // tel2: p.tel2.toString(),
            // uid: p.uid
          });
        });
        if (Listclient.length > 0) {
          this.dataClient.next(Listclient);
        }
      });
  }

  setPartage(mySimulation: any, lstUID: any) {
    let UID = lstUID.uid;
    if (this.authentic.profile.uid === UID) {
      this.actionSimul(
        "Erreur de transfert!",
        "On ne peut pas se transferer une simulation"
      );
      return;
    }
    const { NomPrenom, tel1 } = this.authentic.profile;

    this.db
      .object(`Quittances/${mySimulation.Quittance}`)
      .update({
        idkeyPar: UID,
        NomPrenom: lstUID.NomPrenom,
        namePar: lstUID.NomPrenom + "( " + lstUID.tel1 + " )",
        namePartage: NomPrenom.trim(),
        telPartage: tel1.toString(),
      })
      .then(() => {
        this.db
          .object(
            `Cotations/${this.authentic.profile.uid}/${mySimulation.type}/${mySimulation.key}`
          )
          .update({
            idkeyPar: UID,
            namePar: lstUID.NomPrenom + "( " + lstUID.tel1 + " )",
          })
          .then(() => {
            this._notify.sendNotifyCloud(
              lstUID.registerid,
              mySimulation.Police,
              this.authentic.profile.NomPrenom +
                "( " +
                this.authentic.profile.tel1 +
                " )"
            );
            this.actionSimul(
              "Transfert de simulation !",
              "La simulation " +
                mySimulation.Police +
                " a été transféré avec succès"
            ).then(() => {});
          });
      });
  }
}
